module.exports = __webpack_public_path__ + "img/dsofile01.523ad524.png";